<div class="getting-started-container" [ngClass]="direction == 'left' ? '' : 'reverse' " >

  <div class="step-image">
    <img src="{{image}}" />
  </div>

  <div class="description-getting-started-container">
    <div class="step-number-container">
      {{number}}
    </div>

    <div class="step-description-container">
      <h2> {{title}}</h2>
      <p> {{subtitle}}</p>
    </div>
  </div>

</div>
